export const proxyPolyfillCompat = {
  app: null,
  logEvent: null,
  setCurrentScreen: null,
  setUserId: null,
  setUserProperties: null,
  setAnalyticsCollectionEnabled: null,
};
